import React from "react"
import ContentBody from "./ContentBody"
import SEO from "./seo"

function QFooter({ description, title, image, url, keywords }) {
  return (
    <>
      <footer className="w-full mx-auto relative z-10">
        <ContentBody>
          <div className="container w-full mb-6 p-6 text-center text-slate-600 bg-slate-900 rounded-2xl bg-opacity-60 border border-slate-900">
            <h4>Open AI Logo trademark belongs to OpenAI.</h4>
            <h4>
              App Store, Apple Logo and Safari Browser Logo are trademarks of
              Apple Inc.
            </h4>
          </div>
          <div className="container mx-auto px-4 py-2 flex flex-col gap-4 items-center justify-center">
            <div className="flex flex-wrap items-center justify-start gap-6">
              <a
                href="/contact-us"
                className="text-sm  font-medium tracking-wider uppercase text-slate-700 hover:text-slate-400"
              >
                Contact Us
              </a>
              <a
                href="/hire"
                className="text-sm  font-medium tracking-wider uppercase text-slate-700 hover:text-slate-400"
              >
                Hire Us
              </a>
              <a
                href="/privacy"
                className="text-sm  font-medium tracking-wider uppercase text-slate-700 hover:text-slate-400"
              >
                Privacy
              </a>
              <a
                href="/terms"
                className="text-sm  font-medium tracking-wider uppercase text-slate-700 hover:text-slate-400"
              >
                Terms
              </a>
              <a
                href="/data-protection"
                className="text-sm  font-medium tracking-wider uppercase text-slate-700 hover:text-slate-400"
              >
                Data Protection
              </a>
            </div>
            <div
              style={{
                height: "1px",
              }}
              className="w-full bg-slate-900"
            />
            <div>
              <p className="text-sm text-slate-700">
                {" "}
                © {new Date().getFullYear()}{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://quantumparadox.studio"
                  className="hover:text-slate-600"
                >
                  QuantumParadoxStudio
                </a>{" "}
              </p>
            </div>
          </div>
        </ContentBody>
      </footer>
      <SEO
        title={title}
        description={description}
        url={url}
        image={image}
        keywords={keywords}
      />
    </>
  )
}

export default QFooter
